export var SizeTypeTokens;
(function (SizeTypeTokens) {
    SizeTypeTokens["NONE"] = "NONE";
    SizeTypeTokens["XS"] = "XS";
    SizeTypeTokens["SM"] = "SM";
    SizeTypeTokens["Size6"] = "Size6";
    SizeTypeTokens["MD"] = "MD";
    SizeTypeTokens["Size10"] = "Size10";
    SizeTypeTokens["LG"] = "LG";
    SizeTypeTokens["XL"] = "XL";
    SizeTypeTokens["XXL"] = "XXL";
    SizeTypeTokens["XXXL"] = "XXXL";
    SizeTypeTokens["Size30"] = "Size30";
    SizeTypeTokens["Size32"] = "Size32";
    SizeTypeTokens["XXXXL"] = "XXXXL";
    SizeTypeTokens["XXXXXL"] = "XXXXXL";
    SizeTypeTokens["XXXXXXL"] = "XXXXXXL";
    SizeTypeTokens["Size80"] = "Size80";
    SizeTypeTokens["SIZE18"] = "Size18";
    SizeTypeTokens["SIZE14"] = "Size14";
    SizeTypeTokens["Size1"] = "Size1";
    SizeTypeTokens["SIZE72"] = "SIZE72";
    SizeTypeTokens["SIZE42"] = "SIZE42";
    SizeTypeTokens["SIZE_46"] = "SIZE_46";
    SizeTypeTokens["SIZE_MINUS_16"] = "SIZE_MINUS_16";
    SizeTypeTokens["SIZE_26"] = "SIZE_26";
    SizeTypeTokens["Size_2"] = "Size_2";
})(SizeTypeTokens || (SizeTypeTokens = {}));
export var SpaceOrientation;
(function (SpaceOrientation) {
    SpaceOrientation["HORIZONTAL"] = "horizontal";
    SpaceOrientation["VERTICAL"] = "vertical";
    SpaceOrientation["ALL"] = "all";
})(SpaceOrientation || (SpaceOrientation = {}));
